export enum WebViewScope {
  MOBILE_PRO = 'mobilePro',
  MOBILE_HOMEOWNER = 'mobileHomeowner',
}
